import { apiSlice } from "./apiSlice";

export const noteApi = apiSlice.injectEndpoints({
  keepUnusedDataFor: 1,
  endpoints: (builder) => ({
    getNotes: builder.query({
      query: (params) => ({
        url: `/notes`,
        method: "GET",
        params,
      }),
      transformResponse: (response, meta, arg) => response?.body,
      transformErrorResponse: (response, meta, arg) =>
        response?.data?.message ?? "Something went wrong please try again",
    }),
    getNoteById: builder.query({
      query: (id) => ({
        url: `/notes/${id}`,
        method: "GET",
      }),
      transformResponse: (response, meta, arg) => response?.body,
      transformErrorResponse: (response, meta, arg) =>
        response?.data?.message ?? "Something went wrong please try again",
    }),
    createNote: builder.mutation({
      query: (payload) => ({
        url: `/notes`,
        method: "POST",
        body: { ...payload },
      }),
      transformErrorResponse: (response, meta, arg) =>
        response?.data?.message ?? "Something went wrong please try again",
    }),
   
  }),
});

export const {
  useLazyGetNotesQuery,
  useGetNoteByIdQuery,
  useCreateNoteMutation,
 
} = noteApi;
